import Vue from 'vue'
import Router from 'vue-router'
import Work from '@/components/Work2'
import WorkGallery from '@/components/WorkGallery'
import WorkSpread from '@/components/WorkSpread'
import About from '@/components/About'
import Rendertimecalc from '@/components/Rendertimecalc'
// import Wiki from '@/components/Wiki'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: WorkSpread,
    },
    {
      path: '/work/:id?', //? makes it optional
      name: 'work',
      component: Work,
    },
    {
      path: '/works/:type?',
      name: 'workgallery',
      component: WorkGallery,
    },
    {
      path: '/spread',
      name: 'spread',
      component: WorkSpread,
    },
    {
      path: '/about',
      name: 'about',
      component: About,
    },
    {
      path: '/rendertimecalc',
      name: 'rendertimecalc',
      component: Rendertimecalc,
    },
    // {
    //   path: '/wiki',
    //   name: 'wiki',
    //   component: Wiki,
    // }
  ]
})
